module.exports = function(title) {
    this._sendMessage('set-title', title)
};